<template>
  <div class="siesta-share">
    <p class="text3">Challenge your friends!</p>
    <div class="horizontal center space-evenly">
      <template>
        <img @click="onTwitterClick" src="@/assets/share-twitter.svg" alt />
        <img @click="onFacebookClick" src="@/assets/share-facebook.svg" alt />
      </template>
    </div>
  </div>
</template>

<script>
import { share, embed } from "@/assets/js/social/facebook";
import { sharetwitter } from "@/assets/js/social/twitter";

function isDateBefore(date) {
  return date.getTime() > new Date().getTime();
}

export default {
  props: {
    isResults: Boolean,
    points: Number,
  },
  methods: {
    onShare(type) {
      this.$gtag.event(`${type} Share Click`, {
        // eslint-disable-next-line @typescript-eslint/camelcase
        event_category: "Social Share",
      });
    },
    onFacebookClick() {
      const appID = process.env.VUE_APP_FB_ID;
      embed(appID, undefined, () => {
        share(window.location.origin, this.shareText());
      });
      this.onShare("facebook");
    },
    onTwitterClick() {
      const hashTag = undefined;
      sharetwitter(
        window.location.origin,
        this.shareText(),
        "account",
        hashTag
      );
      this.onShare("twitter");
    },
    shareText() {
      return this.isResults
        ? `I scored ${this.points.toLocaleString()} points in Siesta Sleuth, but I'm keeping the right answers to myself. ${this.playAlong()}`
        : `Spot the difference between the photos to become a Siesta Sleuth and watch ${this.watchMsg()}`;
    },
    playAlong() {
      const isPrior = isDateBefore(new Date("2020-06-16"));
      return isPrior
        ? "Play along and watch a new season of #SiestaKey June 16th at 8/7c on MTV!"
        : "Play along and watch #SiestaKey Tuesdays at 8/7c on MTV!";
    },
    watchMsg() {
      const isPrior = isDateBefore(new Date("2020-06-16"));
      return isPrior
        ? "a new season of #SiestaKey June 16th at 8/7c on MTV!"
        : "#SiestaKey Tuesdays at 8/7c on MTV!";
    },
  },
  computed: {
    shareURL() {
      return window.location.origin;
    },
    shareSupported() {
      return !!window.navigator.share;
    },
  },
};
</script>

<style lang="scss" scoped>
.siesta-share {
  position: absolute;
  bottom: rems(10px);
  right: rems(20px);
}

.text4 {
  margin-bottom: rems(8px);
}
img {
  width: rems(75px);
  height: rems(75px);
  cursor: pointer;
}

.desktop .text3 {
  font-size: rems(16px);
  margin-bottom: rems(10px);
}

.tiny .siesta-share,
.mobile .siesta-share,
.tablet .siesta-share {
  position: static;
  .space-evenly {
    justify-content: center;
  }
  img {
    margin: rems(10px);
  }
}
</style>
